const projectContext = {
  fr: { contextPending: 'Contexte enregistré sur ce téléphone. Synchronisation dès le retour de la connexion.' },
  en: { contextPending: 'Context saved on this phone. It will sync when the connection returns.' },
  es: { contextPending: 'Contexto guardado en este teléfono. Se sincronizará cuando vuelva la conexión.' },
  pt: { contextPending: 'Contexto salvo neste telefone. Será sincronizado quando a conexão voltar.' },
  vi: { contextPending: 'Đã lưu bối cảnh trên điện thoại. Sẽ đồng bộ khi có kết nối trở lại.' },
  hi: { contextPending: 'संदर्भ इस फ़ोन पर सहेजा गया है। कनेक्शन लौटने पर सिंक होगा।' },
  ar: { contextPending: 'تم حفظ السياق على هذا الهاتف. ستتم مزامنته عند عودة الاتصال.' },
  ur: { contextPending: 'سیاق اس فون پر محفوظ ہے۔ رابطہ بحال ہونے پر مطابقت پذیر ہو جائے گا۔' },
};

export default projectContext;
